import React from "react";
import s from './ButtonLighth.module.scss'

export const ButtonLighth = ({onClick = () => {}, value="", disabled }) => {
    return <button onClick={onClick} className={s.formButton} disabled={disabled}>{value}</button>
}